<template>
    <div class="w-100" id="tableVerHistorialAcuerdosClientesBase">
      <ui-modal
        ref="modal"
        title="Historial Acuerdo Cliente"
        class="modal-editar-simple-acuerdo-linea w-100"
        @close="actionSetVisibleModalVerHistorialClientesBase(false), ActionSetZindexTablaModal(false)"
      > 

      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="load"
      >
        <loading />
      </div>

      <data-table
        v-else
        :headers="headers"
        :data="data"
        buscar
        numerador
        :acciones="[]"
        idtabla="modal-editar-simple-acuerdo-linea"
      />
        <!-- Footer -->
        <div class="d-flex justify-content-between mt-2">
          <button class="btn btn-default" @click="closeModal('modal');">
            Cerrar
          </button>
        </div>
      </ui-modal>
    </div>
  </template>
  
<script>
// Common
import { mapActions, mapState } from "vuex";
import DataTable from "../../../../../components/common/DataTable";
import Loading from "../../../../common/loading";

export default {

props:["data","load"],

data() {
    return {
      headers:["Usuario","Acción","Fecha"],
      thisData: this.data
    };
},
methods: {
    ...mapActions(["ActionSetZindexTablaModal"]),
    ...mapActions("lineas", ["actionSetVisibleModalVerHistorialClientesBase"]),
    openModal(ref) {
        this.ActionSetZindexTablaModal(true);
        this.$refs[ref].open();
    },
    closeModal(ref) {
        this.$refs[ref].close();
    },

},
computed: {
    ...mapState(["showAcuerdoLineasClienteBase"]),
    ...mapState("lineas", ["visibleModalVerHistorialClientesBase"]),
    
},
components: {
  DataTable,
  Loading
},
watch: {
    visibleModalVerHistorialClientesBase: function (_new) {
        (_new) && this.openModal("modal");
    },
},
};
</script>
  
  <style>
</style>
  